import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ContentDelivery } from '../Footer Section/ContentDelivery';
import { authHeader, config } from '../../_helpers'
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
// import htmlToImage from 'html-to-image'; 

export class ReviewCartItem extends Component {

    constructor(props) {

        super(props);


        //this.setState({
        //    YourDetails: this.state.YourDetails
        //});


        this.state = {
            key: '2',
            ReviewCartItem: [],
            YourDetails: this.props.YourDetails,
            totalTax: 0,
            EditEmail: 'Edit Email',
            EditAddresses: 'Edit Addresses',
            EditVat: 'Edit Vat',
            totalShipping : 0,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCountriesChange = this.handleCountriesChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }


    componentDidMount() {


        var self = this;
        var CountryId = 0;
        if (this.props.YourDetails == undefined || this.props.YourDetails.length != undefined) {
        }
        else {
            if (this.props.YourDetails.sameAsBilling == null || this.props.YourDetails.sameAsBilling == 'checked') {
                CountryId = this.props.YourDetails.countryId;
            }
            else {
                CountryId = this.props.YourDetails.shippingcountryId;
            }
        }

        appService.getAll('Cart/ReviewOrder?CountryId=' + CountryId + "&billingCountryId=" + this.props.YourDetails.countryId + "&shippingcountryId=" + this.props.YourDetails.shippingcountryId + "&regionId=" + this.props.YourDetails.regionId + "&shippingregionId=" + this.props.YourDetails.shippingregionId).then(function (response) {
            self.setState({
                ReviewCartItem: response.cartProductVM,
                usersubscriptionid: response.usersubscriptionid,
                firstname: self.props.YourDetails.firstname,
                lastname: self.props.YourDetails.lastname,
                organisation: self.props.YourDetails.organisation,
                countryId: self.props.YourDetails.countryId,
                countries: self.props.YourDetails.countries,
                countryName: response.cartUserVM.countryName,
                addressId: self.props.YourDetails.addressId,
                address1: self.props.YourDetails.address1,
                address2: self.props.YourDetails.address2,
                city: self.props.YourDetails.city,
                regionId: self.props.YourDetails.regionId,
                regions: self.props.YourDetails.regions,
                regionName: response.cartUserVM.regionName,
                zip: self.props.YourDetails.zip,
                phoneNo: self.props.YourDetails.phoneNo,
                vatnumber: self.props.YourDetails.vatnumber,
                emailAddress: self.props.YourDetails.emailAddress,
                saveForQuickCheckout: self.props.YourDetails.saveForQuickCheckout,
                //shipping address
                shippingfirstname: self.props.YourDetails.shippingfirstname,
                shippinglastname: self.props.YourDetails.shippinglastname,
                // shippingorganisation: self.props.YourDetails.shippingOrganisation,
                shippingcountryId: self.props.YourDetails.shippingcountryId,
                shippingcountries: self.props.YourDetails.shippingcountries,
                shippingcountryName: response.cartUserVM.shippingCountryName,
                shippingaddressId: self.props.YourDetails.shippingaddressId,
                shippingaddress1: self.props.YourDetails.shippingaddress1,
                shippingaddress2: self.props.YourDetails.shippingaddress2,
                shippingcity: self.props.YourDetails.shippingcity,
                shippingregionId: self.props.YourDetails.shippingregionId,
                shippingregionName: response.cartUserVM.shippingRegionName,
                shippingregions: self.props.YourDetails.shippingregions,
                shippingzip: self.props.YourDetails.shippingzip,
                shippingphoneNo: self.props.YourDetails.shippingphoneNo,
                sameAsBilling: self.props.YourDetails.sameAsBilling,

                //Tax
                totalTax: response.totalTax,
                totalShipping: response.totalShipping,
            });


        });

    }

    handleChange(event) {

        let setvalue = '';
        if (event.target.type == "checkbox") {
            setvalue = event.target.checked
        }
        else {
            setvalue = event.target.value
        }

        this.setState({ [event.target.id]: setvalue });
        let fields = this.state.fields;
        fields[event.target.id] = setvalue;
        this.setState({ fields });
    }

    handleCountriesChange(event) {

        let fields = this.state.fields;
        fields[event.target.id] = event.target.value;
        var self = this;
        self.setState({ [event.target.id]: event.target.value, fields });
        appService.getAll('Cart/GetByCountry?CountryId=' + event.target.value).then(function (response) {
            this.setState({
                regions: response,
            })
        })
    }

    handleSelect(Activekey) {

        if (Activekey == '2') {
            document.getElementById('controlled-tab-example-tab-2').click();
        }

        if (Activekey == '4') {
            var self = this;
            self.setState({
                EditEmail: '',
                EditAddresses: '',
                EditVat: '',
            });

            // htmlToImage.toPng(document.getElementById('maindvcart'), { filter: this.filter })
            //     .then(function (dataUrl) {
            //         let parameters = '';
            //         parameters = { 'user': localStorage.getItem('user').replace("\"", "").replace("\"", ""), 'ImgStr': dataUrl }
            //         appService.getByIssueId('/Cart/SaveImage', parameters)
            //             .then(function (data) {
            //                 document.getElementById('controlled-tab-example-tab-4').click();
            //             });
            //     });

        }

    }

    filter(node) {
        return (node.tagName !== 'i');
    }

    handleResponse(response) {
        return new Promise((resolve, reject) => {
            if (response.ok) {
                // return json if it was returned in the response	
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    response.json().then(json => resolve(json));
                } else {
                    resolve();
                }
            } else {
                // return error message from response body	
                response.text().then(text => reject(text));
            }
        });
    }
    handleError(error) {
        return Promise.reject(error && error.message);
    }

    handleSave(event) {

        if (this.handleValidation()) {
            event.preventDefault();

            appService.getAll('Cart/MakePayment').then(function (response) {
                //this.setState({ MakePayment : response });
            });

            //});

            //endsubmitform
        }
    }


    handleValidation() {

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!this.state.firstname) {
            formIsValid = false;
            errors["firstname"] = "Required field!";
        }

        if (!this.state.lastname) {
            formIsValid = false;
            errors["lastname"] = "Required field!";
        }

        this.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    // Handle Delete request for an employee
    handleDelete(id) {

        if (!window.confirm("Are you sure you want to remove this item?"))
            return;
        else {
            const requestOptions = {
                method: 'Delete',
                headers: authHeader(),
                //body: JSON.stringify({ cart })
            };

            fetch(config.apiUrl + '/Cart/Delete?id=' + id, requestOptions)
                .then(cart => {

                    this.componentDidMount();
                });

             
        }
    }

    up(max, ctrl) {

        if (parseInt(document.getElementById("myNumber" + ctrl).value) + 1 == 11) {
            return false;
        }

        let qty = document.getElementById("myNumber" + ctrl).value;
        let unitPrice = document.getElementById("hdnPrice_" + ctrl).value;

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            //body: JSON.stringify({ cart })
        };

        let updatedQty = parseInt(qty) + 1;
        fetch(config.apiUrl + '/Cart/UpdateQty?id=' + parseInt(ctrl) + '&Quantity=' + updatedQty, requestOptions)
            .then(cart => {

                this.componentDidMount();
            });


        document.getElementById("myNumber" + ctrl).value = parseInt(document.getElementById("myNumber" + ctrl).value, 10) + 1;
        if (document.getElementById("myNumber" + ctrl).value >= parseInt(max, 10)) {
            document.getElementById("myNumber" + ctrl).value = max;
        }

        document.getElementById("spanPrice_" + ctrl).innerText = (unitPrice * document.getElementById("myNumber" + ctrl).value).toFixed(2);
        let currentTotalAmount = parseFloat(document.getElementById("spanTotalAmount").innerText);
        currentTotalAmount += parseFloat(unitPrice);
        document.getElementById("spanTotalAmount").innerText = currentTotalAmount.toFixed(2);

    }
    down(min, ctrl) {
        if (parseInt(document.getElementById("myNumber" + ctrl).value) - 1 == 0) {
            return false;
        }

        let qty = document.getElementById("myNumber" + ctrl).value;
        let unitPrice = document.getElementById("hdnPrice_" + ctrl).value;

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            //body: JSON.stringify({ cart })
        };

        let updatedQty = parseInt(qty) - 1;
        fetch(config.apiUrl + '/Cart/UpdateQty?id=' + parseInt(ctrl) + '&Quantity=' + updatedQty, requestOptions)
            .then(cart => {
                this.componentDidMount();
            });

        document.getElementById("myNumber" + ctrl).value = parseInt(document.getElementById("myNumber" + ctrl).value, 10) - 1;
        if (document.getElementById("myNumber" + ctrl).value <= parseInt(min, 10)) {
            document.getElementById("myNumber" + ctrl).value = min;
        }

        document.getElementById("spanPrice_" + ctrl).innerText = (unitPrice * document.getElementById("myNumber" + ctrl).value).toFixed(2);
        let currentTotalAmount = parseFloat(document.getElementById("spanTotalAmount").innerText);
        currentTotalAmount -= parseFloat(unitPrice);
        document.getElementById("spanTotalAmount").innerText = currentTotalAmount.toFixed(2);

    }

    render() {
        var ReviewCartItem = this.state.ReviewCartItem;
        var totalAmount = 0;
        var totalCurrencySymbol = '';

        var totalTax = this.state.totalTax;
        var totalShipping = this.state.totalShipping;

        var cart = Object.entries(ReviewCartItem).map((item) => {
            totalAmount += parseFloat(item[1].price * item[1].quantity)
            totalCurrencySymbol = item[1].currencySymbol
            return (<li className="list-group-item px-0 py-4" id={'dvitem_' + item[1].id}>
                <div className="row" >
                    <div className="col-lg-1 col-md-2 col-sm-2 col-4"><img alt="" height="120px" src={'./images/books/' + item[1].imageName} /></div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                        {(() => {

                            if (item[1].isDetailProduct == true) {
                                return (
                                    <p className="m-0 p-0 font-400"><div dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></div></p>
                                )
                            }
                            else {
                                return (
                                    <p className="m-0 p-0 font-400"><div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                                )
                            }
                        }
                        )()}
                        <p className="m-0 p-0"><div dangerouslySetInnerHTML={{ __html: item[1].editors }}></div></p>

                        {(() => {
                            if (item[1].isDetailProduct == true) {
                                return (
                                    <p className="m-0 p-0"><div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                                )
                            }
                        }
                        )()}

                    </div>
                    {(() => {
                        if (item[1].deliveryTypeId == '3') {  /*17 for print*/
                            return (<div className="col-lg-2 col-2">
                                <div className="input-group-btn" >
                                    <button id={'down_' + item[1].id} className="btn increment-boxPlus" onClick={() => this.down('1', item[1].id)}><span className="oi oi-minus" style={{ fontSize: '10px', color: '#474747', top: '-3px' }}></span></button>
                                    <input disabled type="text" id={'myNumber' + item[1].id} className="increment-box center" defaultValue={item[1].quantity} />
                                    <button id={'up_' + item[1].id} className="btn increment-boxPlus" onClick={() => this.up('10', item[1].id)}><span className="oi oi-plus" style={{ fontSize: '10px', color: '#474747', top: '-3px' }}></span></button>
                                </div>
                            </div>
                            )
                        }
                        else {
                            return (
                                <div className="col-lg-2 col-md-1 col-sm-1 col-2" style={{ paddingLeft: '4%' }}>1</div>
                            )
                        }
                    }
                    )()}
                    <div className="col-lg-1 col-md-1 col-sm-1 col-3" >{item[1].documentType}</div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-6">{item[1].deliveryType}</div>
                    <input type='hidden' value={item[1].price} id={'hdnPrice_' + item[1].id} />
                    <div id={'dvPrice_' + item[1].id} className="col-lg-1 col-md-1 col-sm-1 col-2 green">{item[1].currencySymbol}<span id={'spanPrice_' + item[1].id}>{(item[1].price * item[1].quantity).toFixed(2)}</span></div>
                    <div className="col-lg-1 col-md-1 col-sm-1 col-1">
                        <a className="action" onClick={(id) => this.handleDelete(item[1].id)}>
                            <span className="oi oi-x gray">
                            </span>
                        </a></div>

                </div>
            </li >)
        })
        const meta = {
            title: "Kluwer Law Online - Review Order",
            //description: "Kluwer Law Online publishes peer-reviewed journals and manuals on various practice areas in international law. Browse within our practice areas to discover which titles we offer in your area of legal practice or on important legal subject-matters.",
            canonical: window.location.href,
            meta: {
                charset: "utf-8",
                name: {
                    keywords: "Shopping cart,Online Shopping,Manuals,practice area in international law,corporate and commercial law, litigation, labour law and transport law"
                }
            }
        }
        return (

            <div id="maindvcart">
            <DocumentMeta {...meta}>
                <div>

                    <ul className="list-group list-group-flush mt-4">
                        <li className="list-group-item px-0 py-4">

                            <div className="row">
                                <div className="col-4">Product(s)</div>
                                <div className="col-2">Quantity</div>
                                <div className="col-1">Type</div>
                                <div className="col-3">Access/delivery</div>
                                <div className="col-1">Price</div>

                            </div>
                        </li>

                        {cart}


                    </ul>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item px-0 Bottomlist">
                            <div className="row">
                                <div className="col-md">
                                </div>
                                <div className="col-1 font-400">Subtotal</div>
                                <div className="col-1 green">{totalCurrencySymbol}<span id='spanTotalAmount'>{(totalAmount < 10) ? ("0" + totalAmount.toFixed(2)) : totalAmount.toFixed(2)}</span></div>
                                <div className="col-1"></div>
                            </div>


                            <div className="row">
                                <div className="col-md">
                                    <p className="m-0 p-0 font-400"></p>
                                    <p className="m-0 p-0"></p>
                                </div>
                                <div className="col-1 font-400">VAT</div>
                                <div className="col-1 green">{totalCurrencySymbol}<span id='spanTotalVAT'>{(totalTax < 10) ? ("0" + totalTax.toFixed(2)) : totalTax.toFixed(2)}</span></div>
                                <div className="col-1"></div>
                            </div>


                            <div className="row">
                                <div className="col-md">
                                    <p className="m-0 p-0 font-400"></p>
                                    <p className="m-0 p-0"></p>
                                </div>
                                    <div className="col-1 font-400">Shipping</div>
                                    <div className="col-1 green">{totalCurrencySymbol}<span id='spanTotalShipping'>{totalShipping.toFixed(2)}</span></div>
                                <div className="col-1"></div>
                            </div>



                            <div className="row">
                                <div className="col-md">
                                    <p className="m-0 p-0 font-400"></p>
                                    <p className="m-0 p-0"></p>
                                </div>
                                    <div className="col-1 font-400">Total</div>
                                    <div className="col-1 green">{totalCurrencySymbol}<span id='spanGrandTotal'>{(totalAmount + totalTax + totalShipping).toFixed(2)}</span></div>
                                <div className="col-1"></div>
                            </div>
                        </li>
                    </ul>

                    <ul className="list-group list-group-flush">
                        <li className="list-group-item px-0 border-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                            <div className="row">
                                <div className="col col-lg-6 font-400" style={{ fontSize: '20px' }}>Company name</div>
                                <div className="col font-400" style={{ fontSize: '20px' }}>VAT number</div>
                                    <div className="col blue text-right HoverUnderline" onClick={() => this.handleSelect("2")}>{this.state.EditVat}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 py-4">
                            <div className="row">
                                <div className="col col-lg-6">{this.state.organisation}</div>
                                <div className="col">{this.state.vatnumber}</div>
                                <div className="col blue text-right"></div>
                            </div>
                        </li>
                        <li className="list-group-item px-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                            <div className="row">
                                <div className="col col-lg-6 font-400" style={{ fontSize: '20px' }}>Billing address</div>
                                <div className="col font-400" style={{ fontSize: '20px' }}>Shipping address</div>
                                    <div className="col blue text-right HoverUnderline" onClick={() => this.handleSelect("2")}>{this.state.EditAddresses}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 py-4">
                            <div className="row">
                                <div className="col col-lg-6">
                                    <p className="m-0 p-0 ">{this.state.firstname + ' ' + this.state.lastname}<br></br>{this.state.address1} {this.state.address2} <br></br>{this.state.regionName}, {this.state.countryName} {this.state.phoneNo}</p>
                                </div>
                                <div className="col">
                                    {(() => {
                                        if (this.state.sameAsBilling == 'checked') {
                                            return (
                                                <p className="m-0 p-0 ">{this.state.firstname + ' ' + this.state.lastname} <br></br>{this.state.address1} {this.state.address2} <br></br>{this.state.regionName}, {this.state.countryName} {this.state.phoneNo}</p>
                                            )
                                        }
                                        else {
                                            return (
                                                <p className="m-0 p-0">{this.state.shippingfirstname + ' ' + this.state.shippinglastname} <br></br>{this.state.shippingaddress1} {this.state.shippingaddress2} <br></br>{this.state.shippingregionName}, {this.state.shippingcountryName} {this.state.shippingphoneNo}</p>
                                            )
                                        }

                                    }
                                    )()}




                                </div>
                                <div className="col blue"></div>
                            </div>
                        </li>
                        <li className="list-group-item px-0" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                            <div className="row">
                                <div className="col col-lg-6 font-400" style={{ fontSize: '20px' }}>Email address</div>
                                <div className="col font-400"></div>
                                    <div className="col blue text-right HoverUnderline" onClick={() => this.handleSelect("2")}>{this.state.Editemail}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 py-4">
                            <div className="row">
                                <div className="col col-lg-6">{this.state.emailAddress}</div>
                            </div>
                        </li>
                    </ul>
                    <br></br>
                    <div className="row my-5">
                        <div className="col">
                            <button type="button" className="btn float-left back-btn rounded-0" onClick={() => this.handleSelect("2")}>Back</button>
                        </div>
                        <div className="col">
                            <button type="button" onClick={() => this.handleSelect("4")} className="btn btn-info next float-right rounded-0">Make payment</button>
                        </div>
                    </div>
                </div>
                </DocumentMeta>
            </div>
        )
    }
}

export default ReviewCartItem;


// WEBPACK FOOTER //
// ./src/components/Shopping Cart/ReviewCartItem.jsx